<!--
  - Copyright (c) 2023. Henry Zilek
  -->

<template>
    <section id="devInfo" :style="{top:  top, left: left}" class="dev-info-container" draggable="true"
             @dragend="moveTo" @dragstart="moveStart">
        <h3>Dev info</h3>
        <div>Status připojení: {{ this.onlineStatus }}</div>
        <div>ViewPort: {{ this.screen }}</div>
        <div>Jmeno: {{ this.$store.state.userName }}</div>
        <div class="el-center">
            <HZBaseButton :target="{text: 'Admin', name: 'Admin', type:'default', hash: '', fa_icon:''}">Administrace
            </HZBaseButton>

            <button class="button text-black" @click="logOut">Odhlásit</button>
        </div>
    </section>
</template>

<script>
import {mapGetters} from "vuex";
import HZBaseButton from "@/support/HZBaseButton.vue";
import router from "@/routes";

export default {
    name: "DevInfoBlock",
    components: {HZBaseButton},
    data() {
        return {
            top: "10px",
            left: "10px",
            startTop: 0,
            startLeft: 0,
        }
    },
    computed: {
        ...mapGetters({
            onlineStatus: 'getOnlineStatus',
            screen: 'viewPortSize'
        }),
    },

    methods: {
        moveStart(x) {
            const left = x.clientX - document.querySelector('#devInfo').getBoundingClientRect().left
            const top = x.clientY - document.querySelector('#devInfo').getBoundingClientRect().top
            this.startLeft = left
            this.startTop = top

        },
        moveTo(x) {
            const left = x.clientX - this.startLeft
            const top = x.clientY - this.startTop
            this.top = top + "px";
            this.left = left + "px";
        },

        logOut() {
            router.push({name: 'Home'})
            setTimeout(() => {
                    this.$store.dispatch('clearUser')
                },
                500
            )

        }
    }


}
</script>

<style scoped>

.dev-info-container {
    color: black;
    position: fixed;
    top: 10px;
    left: 10px;
    background-color: #eeff00;
    opacity: 0.7;
    width: 300px;
    visibility: hidden;
    border: solid 2px red;
}

.develop .dev-info-container {
    visibility: visible;
}

.el-center {
    padding: 10px;
    width: 145px;
}

</style>